import React from "react";
import EcnInput from "../../StyledComponents/EcnInput";
import EcnButton from "../../StyledComponents/EcnButton";
import { FormControlLabel } from "@mui/material";
import { LocalizationProvider, MobileDatePicker } from "@mui/lab";
import AdapterDateFns from "@mui/lab/AdapterDateFns";
import { Icon } from "@iconify/react";
import EcnCheckboxFilled from "../../StyledComponents/EcnCheckbox";

interface EducationGroupProps {
  edu: any;
  index: number;
  onChange: (index: number, field: string, value: any) => void;
  onRemove: (index: number) => void;
  isLast: boolean;
  submitAttempted: any;
  color?: string;
  radius?: string;
}

const EducationGroup = ({
  edu,
  index,
  onChange,
  onRemove,
  isLast,
  submitAttempted,
  color = "#0034BB",
  radius = "0px",
}: EducationGroupProps) => {

  const handleCheckboxChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const isChecked = event.target.checked;
    // Only call onChange for currently_studying; changeHandler will set end_date when needed
    onChange(index, "currently_studying", isChecked);
  };

  return (
    <div className="work-groups">
      <div className="heading">
        <h1>Education {index + 1}</h1>
        <EcnButton
          className="remove-btn"
          color="secondary"
          style={{ color: color }}
          onClick={() => onRemove(index)}
        >
          <Icon icon={"mingcute:close-line"} color={color} />
          Remove
        </EcnButton>
      </div>
      <div className="row">
        <div className="col">
          <p>School*</p>
          <EcnInput
            className="ecn-input"
            helperText={
              submitAttempted && !edu?.institute ? (
                <p className="custom-error-text">Institute is required</p>
              ) : null
            }
            sx={{
              "& .MuiOutlinedInput-root": {
                borderRadius: radius,

                "& fieldset": {
                  borderColor: "#e4e7ec",
                },
                "&:hover fieldset": {
                  borderColor: color,
                },
                "&.Mui-focused fieldset": {
                  borderColor: color,
                },
                "& input": {
                  color: color,
                },
              },
            }}
            name="title"
            value={edu?.institute}
            onChange={(e: any) => onChange(index, "institute", e.target.value)}
          />
        </div>
      </div>
      <div className="row">
        <div className="col">
          <p>Field of Study*</p>
          <EcnInput
            className="ecn-input"
            helperText={
              submitAttempted && !edu?.department ? (
                <p className="custom-error-text">Department is required</p>
              ) : null
            }
            sx={{
              "& .MuiOutlinedInput-root": {
                borderRadius: radius,

                "& fieldset": {
                  borderColor: "#e4e7ec",
                },
                "&:hover fieldset": {
                  borderColor: color,
                },
                "&.Mui-focused fieldset": {
                  borderColor: color,
                },
                "& input": {
                  color: color,
                },
              },
            }}
            name="title"
            value={edu?.department}
            onChange={(e: any) => onChange(index, "department", e.target.value)}
          />
        </div>
      </div>
      <div className="row">
        <div className="col">
          <p>Degree*</p>
          <EcnInput
            className="ecn-input"
            helperText={
              submitAttempted && !edu?.degree ? (
                <p className="custom-error-text">Degree is required</p>
              ) : null
            }
            sx={{
              "& .MuiOutlinedInput-root": {
                borderRadius: radius,

                "& fieldset": {
                  borderColor: "#e4e7ec",
                },
                "&:hover fieldset": {
                  borderColor: color,
                },
                "&.Mui-focused fieldset": {
                  borderColor: color,
                },
                "& input": {
                  color: color,
                },
              },
            }}
            name="title"
            value={edu?.degree}
            onChange={(e: any) => onChange(index, "degree", e.target.value)}
          />
        </div>
      </div>
      <div className="row">
        <div className="col">
          <p>Start Date*</p>
          <LocalizationProvider dateAdapter={AdapterDateFns}>
            <MobileDatePicker
              views={["year", "month"]}
              inputFormat="MM/yyyy"
              disabled={false}
              maxDate={
                // work?.experience_status === 3 || work?.experience_status === 1
                //   ? new Date()
                //   : new Date("2030-01-01T00:00:00.000Z")
                new Date()
              }
              minDate={
                // work?.experience_status === 2
                //   ? new Date()
                //   :
                new Date("2000-01-01T00:00:00.000Z")
              }
              value={edu?.start_date ? new Date(edu?.start_date) : null}
              onChange={(date) => onChange(index, "start_date", date)}
              renderInput={(params) => (
                <EcnInput
                  {...params}
                  className="ecn-input"
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      borderRadius: radius,

                      "& fieldset": {
                        borderColor: "#e4e7ec",
                      },
                      "&:hover fieldset": {
                        borderColor: color,
                      },
                      "&.Mui-focused fieldset": {
                        borderColor: color,
                      },
                      "& input": {
                        color: color,
                      },
                    },
                  }}
                />
              )}
            />
          </LocalizationProvider>
          {submitAttempted && !edu?.start_date ? (
            <p className="custom-error-text">Start Date is required</p>
          ) : null}
        </div>

        <div className="col">
          <p>End Date</p>
          <LocalizationProvider dateAdapter={AdapterDateFns}>
            <MobileDatePicker
              views={["year", "month"]}
              inputFormat="MM/yyyy"
              disabled={edu?.currently_studying}
              maxDate={
                edu?.experience_status === 3
                  ? new Date()
                  : new Date("2030-01-01T00:00:00.000Z")
              }
              minDate={new Date(edu?.start_date)}
              value={
                edu?.currently_studying
                  ? null
                  : edu?.end_date && edu.end_date !== "2030-10-05T14:48:00.000Z"
                    ? new Date(edu?.end_date)
                    : null
              }
              onChange={(date) => onChange(index, "end_date", date)}
              renderInput={(params) => (
                <EcnInput
                  {...params}
                  className="ecn-input"
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      borderRadius: radius,

                      "& fieldset": {
                        borderColor: "#e4e7ec",
                      },
                      "&:hover fieldset": {
                        borderColor: color,
                      },
                      "&.Mui-focused fieldset": {
                        borderColor: color,
                      },
                      "& input": {
                        color: color,
                      },
                    },
                  }}
                />
              )}
            />
          </LocalizationProvider>

          <FormControlLabel
            className="work-label"
            control={
              <EcnCheckboxFilled
                sx={{ color: color }}
                checked={edu?.currently_studying || false}
                onChange={handleCheckboxChange}
                color="primary"
              />
            }
            sx={{
              ".MuiFormControlLabel-label": {
                fontSize: "14px",
                fontWeight: 500,
                color: "#1D2939",
              },
            }}
            label="Currently Pursuing"
          />

          {
            (
              (
                submitAttempted && !edu?.currently_studying && (!edu?.end_date || edu?.end_date === "2030-10-05T14:48:00.000Z")
              ) ||
              (
                submitAttempted && !edu?.currently_studying && (!edu?.end_date || edu.end_date === "2030-10-05T14:48:00.000Z")
              )
            ) ? (
              <p className="custom-error-text">End Date or Currently Pursuing is required</p>
            ) : null
          }
        </div>
      </div>
    </div>
  );
};

export default EducationGroup;
